import { Component, inject } from '@angular/core';
import { AccountServiceBase, ResetPasswordModel } from '@seahorse/auth';
import { Subscription } from 'rxjs';
import { NotificationService } from '@seahorse/common';
import { createForgotPasswordForm } from './forgot-password-form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SeahorseFormsModule } from '@seahorse/forms';
import { SeahorseLayoutModule } from '@seahorse/layout';
import {
  ButtonComponent,
  LanguagePickerComponent,
  LoadingIndicatorComponent,
} from '@seahorse/ui';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'cp-reset-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    SeahorseFormsModule,
    SeahorseLayoutModule,
    ButtonComponent,
    LanguagePickerComponent,
    LoadingIndicatorComponent,
  ],
})
export class ForgotPasswordPage {
  isLoading = false;
  _subscriptions = new Subscription();

  private _accountService = inject(AccountServiceBase);
  private _notificationService = inject(NotificationService);

  form = createForgotPasswordForm();

  resetPasswordRequest() {
    this.form.submit();

    if (!this.form.valid) {
      return;
    }

    const value = this.form.getRawValue();
    const resetPasswordModel = new ResetPasswordModel(value.emailAddress);

    this.isLoading = true;

    this._subscriptions.add(
      this._accountService.resetPassword(resetPasswordModel).subscribe({
        next: (res) => {
          if (!res) {
            this._notificationService.showError('shared.terms.wrong');
            return;
          }

          this._notificationService.showSuccess(
            'account.resetPassword.emailSent',
            'shared.terms.success'
          );
        },
        error: () => {
          this._notificationService.showError('shared.terms.wrong');
        },
        complete: () => {
          this.isLoading = false;
        },
      })
    );
  }
}
